import { lazy } from 'react';
import { retryImport } from './lazyRetry.mjs';

// React.lazy with a retrying loader — see lazyRetry.mjs for why. Use this for
// every `lazy(() => import(...))` in the app (test/lazyRetry.test.js enforces it).
export const lazyRetry = (factory) => lazy(() => retryImport(factory));
